import { Observable } from "@apollo/client";
import { noop } from "@sail/utils";
export function observableFromPromise(promiseOrValue) {
    return new Observable((observer)=>{
        if (promiseOrValue instanceof Promise) {
            promiseOrValue.then((value)=>{
                observer.next(value);
                observer.complete();
            }).catch((e)=>observer.error(e));
        } else {
            observer.next(promiseOrValue);
            observer.complete();
        }
    });
}
export function promiseFromObservable(observable) {
    let subscription = null;
    const promise = new Promise((resolve, reject)=>{
        subscription = observable.subscribe({
            // returned promise is resolved with the first result of Observable
            next: resolve,
            error: reject
        });
    });
    const output = promise.finally(()=>{
        if (subscription) {
            subscription.unsubscribe();
        }
    });
    output.catch(noop);
    return output;
}
export function completeWithError(error) {
    return new Observable((observer)=>observer.error(error));
}

//# sourceMappingURL=observableUtils.js.map